import React from "react"
import { withArtDirection } from "gatsby-plugin-image"
import { getImageData } from "@utils/image"
import * as styles from "./content-grid.module.css"
import ImageBlock from "../image-block"

const ContentGrid = ({ id, items, gridItems, title }) => {
  const columns = items || gridItems
  const columnSize = {
    "1/2": "sm:col-span-1 lg:col-span-6",
    "2/3": "sm:col-span-1 lg:col-span-8",
    "1/3": "sm:col-span-1 lg:col-span-4",
  }

  const textPlacementClasses = {
    "bottom-left": "mt-auto",
  }

  return (
    <div id={id} className="flex flex-col gap-y-5 w-full">
      {title && <h2 tabIndex={0} className="pl-0 md:pl-10">{title}</h2>}
      <div className={`grid gap-8 mb-12 px-4 sm:px-6 sm:grid-cols-2 sm:gap-6 lg:px-8 lg:gap-12 lg:px-12 lg:grid-cols-12 w-full ${styles.root}`}>
        {columns.map(({ _type, _key, columnWidth, ...rest }) => {
          const { text, textPlacement } = rest
          const uid = _key
          const imageAssetId = rest?.image?.asset?._ref || rest?.image?.asset?._id
          const imageWidth = {
            "1/2": 1600,
            "1/3": 580,
            "2/3": 1400
          }[columnWidth] || 1600
          const aspectRatio = columnWidth === "1/3"
            ? 58 / 69
            : 14 / 9
          const width = columnWidth === "1/3"
            ? 600
            : 1600
          const columnClass = columnSize[columnWidth] || columnSize["1/2"]
          const textClass = textPlacementClasses[textPlacement] || ""

          const image = withArtDirection(
            getImageData(imageAssetId, { width: imageWidth, aspectRatio, fit: "crop" }),
            [{
              media: "(max-width: 768px)",
              image: getImageData(imageAssetId, { width, aspectRatio, fit: "crop" }),
            }]
          )

          const imageData = text
            ? { ...image, labels: { labelList: [{ label: text }] } }
            : image

          const imageTitle = text || rest?.text

          return (
            <ImageBlock
              key={uid}
              wrapperClassName={`relative flex rounded-xl overflow-hidden ${columnClass}`}
              className={`w-full ${styles.w12} ${textClass}`}
              image={imageData}
              alt={imageTitle}
            />
          )
        })}
      </div>
    </div>
  )
}

export default ContentGrid
